import { PGTransactions } from "./../../../../../Integrations"
import { useOutletContext } from "react-router"

export default function PGIntegrationItemTransactionsPage() {
	const context = useOutletContext<{ appId: number }>()
	return <PGTransactions appId={context.appId} />
}
